import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import DoneIcon from '@mui/icons-material/Done';

// A line has a check mark. A line with `indent` 1 is a bullet under the line above:
// it starts under the text of that line, not under its check mark.
const TextLabel = ({ field, dataTestid }) => {
  const isBullet = field.indent > 0;

  return (
    <Grid
      container
      item
      key={field.index}
      alignItems="center"
      sx={{ paddingBottom: '10px', paddingLeft: isBullet ? '39px' : 0 }}
    >
      {isBullet ? (
        <Typography
          variant="normal"
          aria-hidden="true"
          data-testid="label_bullet"
          sx={{ width: '12px', marginRight: '10px', color: 'text.secondary' }}
        >
          •
        </Typography>
      ) : (
        <DoneIcon color="iconGrey" sx={{ fontSize: 16, marginRight: '15px' }} />
      )}
      <Typography variant="normal" sx={{ flex: 1 }} data-testid={dataTestid}>
        <FormattedMessage id={field.placeholder} />
      </Typography>
    </Grid>
  );
};

TextLabel.defaultProps = {
  dataTestid: 'data_testid',
};

TextLabel.propTypes = {
  field: PropTypes.object.isRequired,
  dataTestid: PropTypes.string,
};

export default TextLabel;
